//import $ from 'jquery';
import Base from '../../../_config/base';

class CategoryOverview extends Base {
  constructor(el) {
    super(el);

    // Get jQuery object
    this.categoryOverview = this.$el;
    this.showAllBtn = this.categoryOverview.find('.category-overview-show-all');
    this.showAllBtn.bind('click', this.showAllItems.bind(this));
  }

  showAllItems(e) {
    e.preventDefault();
    e.stopPropagation();

    this.categoryOverview.toggleClass('show-all');
    if (this.categoryOverview.hasClass('show-all')) {
      this.showAllBtn.text('Show Less');
    } else {
      this.showAllBtn.text('Show All');
    }
  }
}

CategoryOverview.className = 'CategoryOverview';
export default CategoryOverview;



// WEBPACK FOOTER //
// ./src/materials/molecules/category-overview/category-overview.js